var _path, _g;
import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftTeams = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 168,
  height: 144,
  fill: "none",
  viewBox: "0 0 168 144",
  ...props,
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: 134,
    height: 144,
    x: 17,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M150.716 0H17v144h133.716z"
    }))
  }), _g || (_g = /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "M127.039 27.032c-.444-6.968-3.026-3.666-8.097-3.863-5.457-.213-8.86-1.56-8.84 6.773.013 5.187-.252 15.353 8.117 16.194 8.73.877 9.106-14.638 8.82-19.104M43.124 45.356l-2.18-17.463c-.54-4.322 1.327-8.636 4.937-11.076a11.55 11.55 0 0 1 6.49-1.982c2.405 0 4.639.732 6.491 1.982 3.61 2.44 5.478 6.754 4.938 11.076l-2.18 17.463z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M17 50.858v64.399c0 1.222.744 2.321 1.88 2.775L83.857 144V72.563c0-.649-1.944.62-2.55.39L19.112 49.401A1.56 1.56 0 0 0 17 50.86z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#5E5E5E",
      d: "M150.715 49.882v65.832c0 .946-.575 1.797-1.455 2.148L83.857 144V72.563c0-.648 1.944.62 2.55.39l63.11-23.898a.884.884 0 0 1 1.197.827z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "m71.29 83.838-.003 8.738a.58.58 0 0 1-.791.539l-8.902-3.509a.58.58 0 0 1-.367-.538v-8.573c0-.404.404-.684.782-.54l8.905 3.342a.58.58 0 0 1 .375.543zM71.19 102.534l-.003 8.738a.58.58 0 0 1-.791.538l-8.902-3.508a.58.58 0 0 1-.367-.539v-8.572c0-.404.404-.684.782-.541l8.905 3.342a.58.58 0 0 1 .376.543zM71.053 121.609l-.002 8.738a.578.578 0 0 1-.791.538l-8.903-3.508a.58.58 0 0 1-.367-.538v-8.573c0-.404.404-.684.783-.541l8.905 3.343a.58.58 0 0 1 .375.543z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "m33.407 68.684-.003 8.738a.58.58 0 0 1-.791.538l-8.902-3.508a.58.58 0 0 1-.367-.538V65.34c0-.404.404-.684.782-.541l8.905 3.343a.58.58 0 0 1 .376.543zM52.253 94.867l-.003 8.738a.58.58 0 0 1-.791.538l-8.903-3.509a.58.58 0 0 1-.366-.538v-8.572c0-.404.404-.685.782-.542l8.905 3.343a.58.58 0 0 1 .376.543zM52.143 114.042l-.003 8.738a.578.578 0 0 1-.79.538l-8.903-3.508a.58.58 0 0 1-.367-.539v-8.572c0-.404.404-.684.782-.541l8.906 3.343a.58.58 0 0 1 .375.542z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "m33.25 106.532-.002 8.738a.578.578 0 0 1-.791.538l-8.902-3.508a.58.58 0 0 1-.367-.539v-8.572c0-.404.404-.684.782-.541l8.905 3.343a.58.58 0 0 1 .376.543z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M23.32 93.877c-.003.583.758.804 1.068.311l.153-.243a.58.58 0 0 1 .703-.23l7.334 2.89c.38.15.79-.129.79-.537l.004-8.738a.58.58 0 0 0-.376-.543l-8.905-3.343a.58.58 0 0 0-.782.541v8.966l.01.925z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M25.628 90.347c.43 0 .778-.618.778-1.38 0-.763-.348-1.382-.778-1.382s-.778.619-.778 1.381c0 .763.348 1.381.778 1.381M29.09 90.041c0-.762-.349-1.38-.779-1.38s-.778.618-.778 1.38c0 .763.349 1.381.778 1.381s.779-.618.779-1.38M31.834 91.102c0-.762-.349-1.38-.778-1.38s-.779.618-.779 1.38c0 .763.349 1.381.779 1.381s.778-.618.778-1.38"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M52.42 85.842h.006l.004-9.585a.58.58 0 0 0-.375-.543l-8.905-3.343a.58.58 0 0 0-.783.541v8.573c0 .237.146.451.367.538l7.69 3.032c.1.04.187.106.251.192l.703.943a.578.578 0 0 0 1.042-.349"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M44.71 79.266c.43 0 .778-.619.778-1.381 0-.763-.348-1.381-.778-1.381s-.778.618-.778 1.38c0 .763.348 1.382.778 1.382M47.397 80.342c.43 0 .779-.618.779-1.38 0-.763-.349-1.382-.779-1.382s-.778.619-.778 1.381c0 .763.349 1.381.778 1.381M50.142 81.404c.43 0 .778-.619.778-1.382s-.349-1.38-.779-1.38-.778.618-.778 1.38c0 .763.349 1.381.779 1.381"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "m114.676 76.063.002 8.738a.58.58 0 0 0 .792.538l8.902-3.509a.58.58 0 0 0 .367-.538V72.72a.58.58 0 0 0-.783-.542l-8.905 3.344a.58.58 0 0 0-.375.542zM95.848 102.298l.002 8.738c0 .408.412.688.791.538l8.903-3.508a.58.58 0 0 0 .367-.539v-8.572a.58.58 0 0 0-.783-.541l-8.905 3.343a.58.58 0 0 0-.375.542zM95.96 121.39l.004 8.738c0 .409.411.689.791.539l8.902-3.509a.58.58 0 0 0 .367-.538v-8.573a.578.578 0 0 0-.782-.541l-8.906 3.343a.58.58 0 0 0-.375.543z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "m133.555 68.49.003 8.738c0 .408.411.688.791.538l8.902-3.508a.58.58 0 0 0 .367-.539v-8.572a.58.58 0 0 0-.783-.541l-8.905 3.343a.58.58 0 0 0-.375.542z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "m114.709 94.672.003 8.738c0 .409.411.689.791.539l8.902-3.509a.58.58 0 0 0 .367-.538v-8.573a.578.578 0 0 0-.782-.54l-8.906 3.342a.58.58 0 0 0-.375.543zM114.902 113.826l.003 8.738a.58.58 0 0 0 .791.539l8.903-3.509a.58.58 0 0 0 .367-.538v-8.573a.58.58 0 0 0-.783-.541l-8.905 3.343a.58.58 0 0 0-.376.543z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "m133.838 106.196.003 8.738c0 .409.411.689.791.539l8.902-3.509a.58.58 0 0 0 .367-.538v-8.573a.578.578 0 0 0-.782-.541l-8.906 3.343a.58.58 0 0 0-.375.543z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M95.738 94.013c-.003.582.759.804 1.068.31l1.287-2.045a.57.57 0 0 1 .277-.23l7.049-2.779a.58.58 0 0 0 .367-.538v-8.573a.578.578 0 0 0-.783-.54l-8.905 3.342a.58.58 0 0 0-.375.543l.004 9.587.01.924z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M103.597 86.587c.43 0 .778-.618.778-1.38 0-.763-.348-1.382-.778-1.382s-.779.618-.779 1.381.349 1.38.779 1.38M100.911 87.664c.43 0 .779-.619.779-1.381 0-.763-.349-1.381-.779-1.381s-.778.618-.778 1.38c0 .763.348 1.382.778 1.382M98.165 88.725c.43 0 .778-.618.778-1.381s-.348-1.38-.778-1.38-.778.617-.778 1.38.348 1.38.778 1.38"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M142.712 94.724c.311.493 1.072.271 1.069-.312l-.023-4.338h-.001v-6.292a.58.58 0 0 0-.783-.54l-8.905 3.342a.58.58 0 0 0-.376.543l.003 8.738c0 .408.412.688.791.538l6.99-2.755a.58.58 0 0 1 .703.23l.532.847z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M141.44 90.13c.43 0 .779-.618.779-1.381s-.349-1.381-.779-1.381c-.429 0-.778.618-.778 1.38 0 .764.349 1.382.778 1.382M138.755 91.205c.43 0 .778-.618.778-1.38 0-.763-.348-1.381-.778-1.381s-.778.618-.778 1.38c0 .763.348 1.381.778 1.381M136.009 92.266c.43 0 .778-.618.778-1.38 0-.763-.348-1.382-.778-1.382s-.779.619-.779 1.381c0 .763.349 1.381.779 1.381"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "m18.646 47.561 63.277-23.656a4.95 4.95 0 0 1 3.462-.003l63.682 23.665c2.197.817 2.199 3.925.003 4.744L85.599 75.968a4.96 4.96 0 0 1-3.461 0L18.647 52.304c-2.195-.819-2.196-3.923-.003-4.743z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#B26E3D",
      d: "M66.867 28.465a1.89 1.89 0 0 0-1.227 2.372l2.768 8.688a1.89 1.89 0 0 0 2.372 1.225h.001a1.89 1.89 0 0 0 1.226-2.372l-2.768-8.687a1.89 1.89 0 0 0-2.372-1.226"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "M67.869 35.006a3.63 3.63 0 0 1-3.202-1.915l-1.685-3.14a3 3 0 0 1-.16-.34c-.978-2.39-4.104-4.321-6.863-6.025q-.44-.27-.862-.534a3.63 3.63 0 0 1 3.848-6.156l.83.514c3.467 2.142 7.77 4.8 9.684 9.26l1.604 2.988a3.63 3.63 0 0 1-3.196 5.348z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#919191",
      d: "m58.062 41.69 6.564 3.112c.2.094.43.1.634.014l10.29-4.298a.78.78 0 0 0 .075-1.403l-5.545-3.041a.79.79 0 0 0-.649-.047l-11.31 4.228a.78.78 0 0 0-.06 1.434z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "m59.932 41.02 6.847 3.112 9.802-4.027-5.715-3.006z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#919191",
      d: "M64.67 35.407v8.397a.84.84 0 0 0 1.161.775l12.065-5.02a.84.84 0 0 0 .517-.776v-8.39a.84.84 0 0 0-1.16-.775l-12.066 5.014a.84.84 0 0 0-.517.775"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#B26E3D",
      d: "M50.302 40.194za1.89 1.89 0 0 0 1.787 1.983l9.106.473a1.89 1.89 0 0 0 1.983-1.788v-.001a1.89 1.89 0 0 0-1.788-1.983l-9.105-.473a1.89 1.89 0 0 0-1.983 1.788"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "M54.956 44.435q-.067 0-.132-.003l-11.668-.416a3.63 3.63 0 0 1-3.487-3.323c-.024-.29-.58-7.24 1.345-16.451a3.63 3.63 0 0 1 7.106 1.485 61 61 0 0 0-1.273 11.157l8.236.294a3.63 3.63 0 0 1-.127 7.257"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#B26E3D",
      d: "M49.882 13.355a2.42 2.42 0 1 0 0-4.842 2.42 2.42 0 0 0 0 4.842"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M118.725 19.145s-2.526-9.133 3.085-8.923c4.871.182 3.306 10.338 3.306 10.338l-6.391-1.416z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#DDB89E",
      d: "M121.367 16.262a2.359 2.359 0 1 0 0-4.718 2.359 2.359 0 0 0 0 4.718"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#474747",
      d: "M120.311 11.076s.211.968 1.237 1.765 2.724 1.336 2.724 1.336l-.677-2.279-1.739-1.02-1.545.2z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#ABABAB",
      d: "M120.247 44.93a3.665 3.665 0 0 1-.871-7.226l3.52-.862-1.668-9.501c-.141-.787-.511-1.503-1.041-2.003a3.37 3.37 0 0 0-2.076-.928 3.66 3.66 0 0 0-2.075.479L98.944 35.47a3.666 3.666 0 0 1-6.192-2.238l-.01-.092a3.67 3.67 0 0 1 1.714-3.513l17.764-10.999.076-.045a10.96 10.96 0 0 1 6.32-1.487c2.446.17 4.79 1.202 6.598 2.907 1.663 1.569 2.81 3.719 3.23 6.054l1.779 10.136a6.16 6.16 0 0 1-3.634 7.245 4 4 0 0 1-.524.172l-4.944 1.212a3.7 3.7 0 0 1-.876.106z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M108.478 41.115s.902-.217.888.549c-.015.765-1.288 1.736-1.288 1.736v.688s1.817-1.213 1.922-2.527c.106-1.314-1.492-1.115-1.492-1.115z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M103.84 45.084c.702.514 3.017.734 3.931 0s.794-5.604.794-5.604h-5.809s.405 5.108 1.084 5.604"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M105.661 40.912c1.603 0 2.904-.642 2.904-1.433 0-.792-1.301-1.434-2.904-1.434-1.605 0-2.905.642-2.905 1.434s1.3 1.433 2.905 1.433"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M105.66 40.66c1.335 0 2.416-.53 2.416-1.181 0-.652-1.081-1.181-2.416-1.181s-2.416.529-2.416 1.181 1.082 1.181 2.416 1.181"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#DDB89E",
      d: "M109.334 42.15v.001a1.88 1.88 0 0 0 2.04 1.7l9.046-.82a1.88 1.88 0 0 0 1.701-2.04v-.002a1.88 1.88 0 0 0-2.041-1.7l-9.046.821a1.877 1.877 0 0 0-1.7 2.04M97.822 32.527a1.595 1.595 0 1 0-2.481 2.004l4.232 5.241a1.595 1.595 0 1 0 2.481-2.003z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M54.557 52.65s-1.004-.24-.987.61c.017.852 1.431 1.93 1.431 1.93v.764s-2.018-1.35-2.136-2.81c-.117-1.459 1.658-1.237 1.658-1.237z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M59.815 57.119c-.73.634-3.458.756-4.474-.06-1.015-.817-.882-6.228-.882-6.228h6.454s-.113 5.431-1.1 6.288z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M57.688 52.426c1.783 0 3.227-.713 3.227-1.593s-1.444-1.594-3.227-1.594-3.227.714-3.227 1.594 1.445 1.593 3.227 1.593"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "M57.688 52.147c1.483 0 2.686-.589 2.686-1.314s-1.203-1.314-2.686-1.314c-1.484 0-2.686.588-2.686 1.314 0 .725 1.202 1.314 2.686 1.314"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#919191",
      d: "m139.019 50.874-12.347 4.984a.55.55 0 0 1-.427-.008l-6.314-2.821c-.439-.196-.429-1.7.015-1.884l12.004-4.03a.55.55 0 0 1 .414 0l6.658 1.867c.451.187.448 1.708-.005 1.89z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "m139.019 49.994-12.347 4.984a.55.55 0 0 1-.427-.007l-6.314-2.822a.545.545 0 0 1 .015-1.002l12.004-4.91a.55.55 0 0 1 .414 0l6.658 2.748a.545.545 0 0 1-.005 1.01z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#777",
      d: "m137.213 49.897-10.232 3.952a.46.46 0 0 1-.334-.006l-4.642-2.105a.39.39 0 0 1 .013-.735l9.736-3.799c.104-.04.22-.04.324 0l5.138 1.952a.391.391 0 0 1-.003.741"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M87.8 57.19c4.562 0 8.26-1.778 8.26-3.972s-3.698-3.973-8.26-3.973c-4.56 0-8.259 1.778-8.259 3.973s3.698 3.972 8.26 3.972"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#F0F0F0",
      d: "M87.802 56.027c3.225 0 5.84-1.258 5.84-2.81 0-1.55-2.615-2.809-5.84-2.809-3.226 0-5.841 1.258-5.841 2.81 0 1.55 2.615 2.808 5.84 2.808"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M91.295 53.938c1.602-.11 2.852-.911 2.791-1.79-.06-.877-1.407-1.5-3.009-1.39s-2.852.91-2.792 1.788 1.408 1.501 3.01 1.392"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M87.68 56.587c1.601-.11 2.851-.91 2.791-1.788s-1.407-1.501-3.01-1.391c-1.601.11-2.851.91-2.79 1.788s1.406 1.501 3.008 1.391"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "M84.662 53.923c1.605 0 2.907-.714 2.907-1.594s-1.302-1.593-2.907-1.593c-1.606 0-2.908.713-2.908 1.593s1.302 1.594 2.907 1.594"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "m131.362.1 16.341 6.306c.769.297 1.298 1.215 1.298 2.256v5.674c0 1.59-1.191 2.723-2.362 2.246l-16.341-6.66c-.757-.309-1.271-1.218-1.271-2.247V2.356c0-1.575 1.171-2.706 2.335-2.256"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#00D639",
      d: "m132.451 3.808-4.713 8.209 6.999-5.334z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M136.265 8.782c.429 0 .778-.618.778-1.38 0-.763-.349-1.382-.778-1.382s-.779.619-.779 1.381c0 .763.349 1.381.779 1.381M139.729 8.478c0-.763-.349-1.38-.779-1.38s-.778.617-.778 1.38.348 1.38.778 1.38.779-.617.779-1.38M142.474 9.539c0-.763-.348-1.381-.778-1.381s-.778.618-.778 1.38c0 .764.348 1.382.778 1.382s.778-.618.778-1.381"
    })]
  }))]
});
export default SvgMicrosoftTeams;